export default "__VITE_ASSET__B20sXL7p__"